import { tileGroupName } from './tile-group-name';

export interface Tile {
    groupName: string | undefined;
    iconClass: string;
    iconText: string;
    id: string;
    isSeparator: boolean;
    name: string;
    tags: string | undefined;
    dividerText?: string;
}

export interface TileDivider {
    id: string;
    dividerText: string;
    dividerIcon?: string;
}

export const createTileDivider = (dividerText: string): TileDivider => {
    switch (dividerText) {
        // Applicable for home page only
        case tileGroupName.Break:
            return {
                id: tileGroupName.Break,
                dividerText: 'DIALOG.BREAK.TITLE',
                dividerIcon: 'fa fa-mug-saucer',
            };
        case tileGroupName.EndBreak:
            return {
                id: tileGroupName.EndBreak,
                dividerText: 'GENERAL.TITLE.END_BREAK',
                dividerIcon: 'fa fa-mug-saucer',
            };
        case tileGroupName.WorkDay:
            return {
                id: tileGroupName.WorkDay,
                dividerText: 'GENERAL.TITLE.WORK_DAY',
                dividerIcon: 'fa fa-briefcase',
            };
        // mapTimeRegistrationDefinitionToTileCommon pages including Select Activity, Select Employee page
        case tileGroupName.All:
            return { id: tileGroupName.All, dividerText: 'GENERAL.TITLE.ALL', dividerIcon: 'fa fa-list' };
        case tileGroupName.Recent:
            return {
                id: tileGroupName.Recent,
                dividerText: 'GENERAL.TITLE.RECENT',
                dividerIcon: 'fa fa-clock',
            };
        default:
            return { id: tileGroupName.Unknown, dividerText };
    }
};
